const navigationContainers = document.querySelectorAll('.in-page-navigation');

function evaluateInPageNavLinkTargets() {
  navigationContainers.forEach(navigationContainer => {
    navigationContainer.querySelectorAll('.in-page-navigation__link--pending').forEach(link => {
      const href = link.getAttribute('href');
      if (!href) return;
      const targetElement = document.getElementById(href.substring(1));
      if (targetElement) {
        link.classList.remove('in-page-navigation__link--pending');
      }
    });
  });
}

document.addEventListener('in-page-navigation:re-evaluate', evaluateInPageNavLinkTargets);

navigationContainers.forEach(navigationContainer => {
  const navigationLinks = navigationContainer.querySelectorAll('.in-page-navigation__link');

  if (navigationLinks) {
    // Reveal pending fragment links whose targets exist in the DOM
    navigationContainer.querySelectorAll('.in-page-navigation__link--pending').forEach(link => {
      const href = link.getAttribute('href');
      if (!href) return;
      const targetElement = document.getElementById(href.substring(1));
      if (targetElement) {
        link.classList.remove('in-page-navigation__link--pending');
      }
    });

    navigationLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent default browser behavior
        
        // Remove active class from all links
        navigationLinks.forEach(otherLink => {
          otherLink.classList.remove('in-page-navigation__link--active');
        });
        
        // Add active class to clicked link
        this.classList.add('in-page-navigation__link--active');
        
        // Handle smooth scrolling to target
        const href = this.getAttribute('href');
        if (href && href.startsWith('#')) {
          const targetId = href.substring(1);
          const targetElement = document.getElementById(targetId);
          
          if (targetElement) {
            // Modal targets are opened via the URL fragment (handled by modal.js),
            // not scrolled to — they are hidden until their hash is active.
            if (targetElement.classList.contains('modal')) {
              window.location.hash = href;
              return;
            }

            // Determine scroll direction
            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            const currentPosition = window.pageYOffset;
            const willScrollUp = targetPosition < currentPosition;

            const stickyAddToCartBannerHeight = document.querySelector('.sticky-add-to-cart-banner ')?.offsetHeight || 0;
            const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
            const totalHeight = stickyAddToCartBannerHeight + headerHeight;
            
            // Update CSS variable BEFORE scrolling based on future header state
            if (willScrollUp) {
              // Scrolling up - header will be visible
              document.documentElement.style.setProperty('--scroll-margin-top', `${totalHeight}px`);
            } else {
              // Scrolling down - header will be hidden
              document.documentElement.style.setProperty('--scroll-margin-top', `${stickyAddToCartBannerHeight}px`);
            }
            
            targetElement.scrollIntoView({
              block: 'start'
            });
          }
        }
      });
    });
  }
});

